export default {
    methods: {
        can(permission) {

            let user = this.getUser()

            if (user.roles.find(role => role.name.toLowerCase() === 'master') !== undefined) {
                return true
            }

            return this.getUserPermissions().find(userPermission => userPermission.name === permission) !== undefined
        },
    }
}
